import React from 'react';
import { brandGradient, radius, colors, typography } from '../theme';
/**
 * Displays the extension icon from /images/[extId]/icon.png.
 * Falls back to a gradient square with the abbreviation text if the image
 * returns a 404 or fails to load for any reason.
 */
export const ExtensionIcon = ({ extId, abbr, size = 56, }) => {
    const [imageError, setImageError] = React.useState(false);
    const containerStyle = {
        width: size,
        height: size,
        borderRadius: radius.icon,
        flexShrink: 0,
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    };
    if (imageError) {
        return (React.createElement("div", { style: {
                ...containerStyle,
                background: brandGradient,
            }, "aria-label": abbr, role: "img" },
            React.createElement("span", { style: {
                    color: colors.white,
                    fontSize: Math.round(size * 0.25),
                    fontFamily: typography.fontFamily,
                    fontWeight: 700,
                    letterSpacing: '0.04em',
                    lineHeight: 1,
                } }, abbr)));
    }
    return (React.createElement("div", { style: containerStyle },
        React.createElement("img", { src: `/images/${extId}/icon.png`, alt: abbr, width: size, height: size, style: { display: 'block', borderRadius: radius.icon }, onError: () => setImageError(true) })));
};
